// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__34pAf","container":"Avatar_container__1IAaC"};